import AddPatientPage from './AddPatientPage';

export default AddPatientPage;
